<template>
  <RowWithDotsMenu class="section">
    <div style="display: flex">
      <v-text-field
        v-model="link.text"
        outlined
        dense
        placeholder="Text"
        autocomplete="off"
        @input="onInputChange($event, [...fullpath, index, 'text'])"
        :disabled="block.hasOwnProperty('disableInputs')"
      ></v-text-field>
      <v-text-field
        v-model="link.href"
        outlined
        dense
        placeholder="Href"
        autocomplete="off"
        @input="onInputChange($event, [...fullpath, index, 'href'])"
        :disabled="block.hasOwnProperty('disableInputs')"
        class="ml-2"
        append-icon="mdi-dots-vertical"
        @click:append="showProjectPagesMenu"
      ></v-text-field>
    </div>
    <!--  -->
    <v-menu
      :position-x="x"
      :position-y="y"
      absolute
      :close-on-content-click="false"
      v-model="showPagesMenu"
    >
      <v-card>
        <div style="font-size: 15px' font-weight: bold;" class="pa-2">
          You can select an existing page
        </div>
        <v-divider></v-divider>
        <div class="pa-2">
          <div
            class="page"
            :class="{ selected: link.href === page.url }"
            v-for="page in projectPages"
            :key="page.id"
            @click="onPageSelect(page, link)"
          >
            <span>{{ page.name }}</span>
          </div>
        </div>
      </v-card>
    </v-menu>
    <!--  -->
    <template v-slot:menu>
      <v-card>
        <div class="pa-2">
          <v-switch
            v-model="link.isNewTab"
            label="Open in New Tab?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'isNewTab',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <v-switch
            v-model="link.showArrow"
            label="Show Arrow?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'showArrow',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <v-switch
            v-if="link.showArrow"
            v-model="link.enableArrowAnimation"
            label="Animate Arrow on Hover?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'enableArrowAnimation',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <v-switch
            v-model="link.isButton"
            label="Show as Button?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'isButton',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <div class="d-flex">
            <v-switch
              v-model="link.activateStripe"
              label="Activate Stripe"
              @change="
                onInputChange($event ? true : false, [
                  ...fullpath,
                  index,
                  'activateStripe',
                ])
              "
              dense
              flat
              inset
              :disabled="block.hasOwnProperty('disableInputs')"
            ></v-switch>
            <v-btn
              v-if="link.activateStripe"
              @click="stripeConfigDialog = true"
              icon
              small
              class="ml-2"
              :disabled="block.hasOwnProperty('disableInputs')"
            >
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </div>
          <v-dialog v-model="stripeConfigDialog" width="600px">
            <LinkStripeConfiguration
              :block="block"
              v-if="stripeConfigDialog"
              :link="link"
              @close="stripeConfigDialog = false"
            ></LinkStripeConfiguration>
          </v-dialog>
          <v-switch
            v-if="link.isButton"
            v-model="link.isOutlined"
            label="Outlined?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'isOutlined',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <v-switch
            v-if="link.isButton"
            v-model="link.isShadowed"
            label="Shadow?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'isShadowed',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <v-switch
            v-model="link.small"
            label="Smaller?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'small',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <v-switch
            v-model="link.executeScript"
            label="Execute Script before click?"
            @change="
              onInputChange($event ? true : false, [
                ...fullpath,
                index,
                'executeScript',
              ])
            "
            dense
            flat
            inset
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-switch>
          <v-textarea
            v-if="link.executeScript"
            v-model="link.script"
            placeholder="Eg.: alert('It works!');"
            @change="onInputChange($event, [...fullpath, index, 'script'])"
            rows="2"
            outlined
            dense
            :disabled="block.hasOwnProperty('disableInputs')"
          ></v-textarea>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            text
            @click="deleteLink(index, link)"
            color="red"
            small
            :disabled="block.hasOwnProperty('disableInputs')"
            >Delete link</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </RowWithDotsMenu>
</template>

<script>
import RowWithDotsMenu from "./RowWithDotsMenu";
import LinkStripeConfiguration from "./LinkStripeConfiguration";
import projectMixin from "../project-mixin";

export default {
  components: { RowWithDotsMenu, LinkStripeConfiguration },
  mixins: [projectMixin],
  props: ["link", "block", "label", "fullpath", "index"],
  data() {
    return {
      stripeConfigDialog: false,
      showPagesMenu: false,
      x: 0,
      y: 0,
    };
  },
  methods: {
    addLink() {
      const item = {
        id: this.randomId(),
        href: "/",
        text: "Link",
        isNewTab: false,
        showArrow: false,
        enableArrowAnimation: false,
        isButton: false,
        activateStripe: false,
        isOutlined: false,
        isShadowed: false,
        small: false,
        stripeConfig: {
          productId: "",
          planId: "",
          successUrl: "",
          cancelUrl: "",
          publishableApiKey: "",
        },
        executeScript: false,
        script: null,
      };
      this.ADD_BLOCK_LIST_ITEM({
        id: this.block.id,
        prop: this.fullpath,
        item,
      });
    },
    deleteLink(index, link) {
      this.DELETE_BLOCK_LIST_ITEM({
        id: this.block.id,
        prop: this.fullpath,
        index,
        targetId: link.id,
      });
    },
    onInputChange(value, prop) {
      this.UPDATE_BLOCK_PROP({ id: this.block.id, prop, value });
    },
    showProjectPagesMenu(e) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showPagesMenu = true;
      });
    },
    onPageSelect(page, link) {
      link.href = page.url;
      this.onInputChange(page.url, [...this.fullpath, this.index, "href"]);
      this.showPagesMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  // margin-bottom: 4px;
  padding: 4px;
  cursor: pointer;
  padding: 0px 4px;

  &:hover {
    background-color: #ececec;
  }

  &.selected {
    font-weight: bold;
    color: #292961;
  }
}
</style>